/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DirectSaleResponse
 */
export interface DirectSaleResponse {
    /**
     * 
     * @type {string}
     * @memberof DirectSaleResponse
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof DirectSaleResponse
     */
    paymentReference: string;
}

/**
 * Check if a given object implements the DirectSaleResponse interface.
 */
export function instanceOfDirectSaleResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderReference" in value;
    isInstance = isInstance && "paymentReference" in value;

    return isInstance;
}

export function DirectSaleResponseFromJSON(json: any): DirectSaleResponse {
    return DirectSaleResponseFromJSONTyped(json, false);
}

export function DirectSaleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectSaleResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
    };
}

export function DirectSaleResponseToJSON(value?: DirectSaleResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderReference': value.orderReference,
        'paymentReference': value.paymentReference,
    };
}

